<template>
  <div class="navigation-item-popover">
    <div class="navigation-item-popover__title">{{ $t(title) }}</div>

    <NavigationSubItems
      v-if="items.length"
      :items="items"
      class="navigation-item-popover__sub-menu"
    />
  </div>
</template>

<script>
import NavigationSubItems from './NavigationSubItems';
export default {
  name: 'NavigationItemPopover',
  components: { NavigationSubItems },
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.navigation-item-popover {
  width: 100%;

  &__sub-menu {
    min-width: rem-calc(120px);
    border-top: 4px solid #eee;
    padding: 0;
    margin: $global-margin/2 0 0 0;

    a {
      padding-right: 0;
      padding-left: 0;
    }
  }
}
</style>
